import * as React from 'react';
import questions from './questions.json';
import QuestionTemplate from './QuestionTemplate';

export default function Lead() {
  return (
    <div className="question-container">
      {Object.entries(questions.lead).map(([key, value], index) => (
        <QuestionTemplate
          key={key}
          identifier={key}
          type={value.type}
          label={value.label}
          event={'lead'}
        />
      ))}
    </div>
  );
}
